export default "__VITE_ASSET__CzdxfeH7__"